/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PayByAccessorialType {
    PerMile = 1,
    PercOfAcc = 2,
    Flat = 3,
    PerKM = 5,
    PercOfDLP = 11,
    RelPercOfRev = 12,
    TariffFuelTable = 13,
}
